import { certificate_level_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCertificateLevelTypeEnum = (enumValue: certificate_level_type_enum) => {
  switch (enumValue) {
    case certificate_level_type_enum.BREEAM_EXCELLENT:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-BREEAM_EXCELLENT" />;
    case certificate_level_type_enum.BREEAM_GOOD:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-BREEAM_GOOD" />;
    case certificate_level_type_enum.BREEAM_OUTSTANDING:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-BREEAM_OUTSTANDING" />;
    case certificate_level_type_enum.BREEAM_PASS:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-BREEAM_PASS" />;
    case certificate_level_type_enum.BREEAM_UNCLASSIFIED:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-BREEAM_UNCLASSIFIED" />;
    case certificate_level_type_enum.BREEAM_VERY_GOOD:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-BREEAM_VERY_GOOD" />;
    case certificate_level_type_enum.DGNB_BRONZE:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-DGNB_BRONZE" />;
    case certificate_level_type_enum.DGNB_GOLD:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-DGNB_GOLD" />;
    case certificate_level_type_enum.DGNB_PLATINUM:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-DGNB_PLATINUM" />;
    case certificate_level_type_enum.DGNB_SILVER:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-DGNB_SILVER" />;
    case certificate_level_type_enum.HQE_EXCELLENT:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-HQE_EXCELLENT" />;
    case certificate_level_type_enum.HQE_GOOD:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-HQE_GOOD" />;
    case certificate_level_type_enum.HQE_OUTSTANDING:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-HQE_OUTSTANDING" />;
    case certificate_level_type_enum.HQE_VERY_GOOD:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-HQE_VERY_GOOD" />;
    case certificate_level_type_enum.LEED_CERTIFIED:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-LEED_CERTIFIED" />;
    case certificate_level_type_enum.LEED_GOLD:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-LEED_GOLD" />;
    case certificate_level_type_enum.LEED_PLATINUM:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-LEED_PLATINUM" />;
    case certificate_level_type_enum.LEED_SILVER:
      return <Trans i18nKey="Enum_CertificateLevelTypeEnum-LEED_SILVER" />;
  }
};

export const translateCertificateLevelTypeEnum_dynamic = (enumValue: certificate_level_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case certificate_level_type_enum.BREEAM_EXCELLENT:
      return t('Enum_CertificateLevelTypeEnum-BREEAM_EXCELLENT');
    case certificate_level_type_enum.BREEAM_GOOD:
      return t('Enum_CertificateLevelTypeEnum-BREEAM_GOOD');
    case certificate_level_type_enum.BREEAM_OUTSTANDING:
      return t('Enum_CertificateLevelTypeEnum-BREEAM_OUTSTANDING');
    case certificate_level_type_enum.BREEAM_PASS:
      return t('Enum_CertificateLevelTypeEnum-BREEAM_PASS');
    case certificate_level_type_enum.BREEAM_UNCLASSIFIED:
      return t('Enum_CertificateLevelTypeEnum-BREEAM_UNCLASSIFIED');
    case certificate_level_type_enum.BREEAM_VERY_GOOD:
      return t('Enum_CertificateLevelTypeEnum-BREEAM_VERY_GOOD');
    case certificate_level_type_enum.DGNB_BRONZE:
      return t('Enum_CertificateLevelTypeEnum-DGNB_BRONZE');
    case certificate_level_type_enum.DGNB_GOLD:
      return t('Enum_CertificateLevelTypeEnum-DGNB_GOLD');
    case certificate_level_type_enum.DGNB_PLATINUM:
      return t('Enum_CertificateLevelTypeEnum-DGNB_PLATINUM');
    case certificate_level_type_enum.DGNB_SILVER:
      return t('Enum_CertificateLevelTypeEnum-DGNB_SILVER');
    case certificate_level_type_enum.HQE_EXCELLENT:
      return t('Enum_CertificateLevelTypeEnum-HQE_EXCELLENT');
    case certificate_level_type_enum.HQE_GOOD:
      return t('Enum_CertificateLevelTypeEnum-HQE_GOOD');
    case certificate_level_type_enum.HQE_OUTSTANDING:
      return t('Enum_CertificateLevelTypeEnum-HQE_OUTSTANDING');
    case certificate_level_type_enum.HQE_VERY_GOOD:
      return t('Enum_CertificateLevelTypeEnum-HQE_VERY_GOOD');
    case certificate_level_type_enum.LEED_CERTIFIED:
      return t('Enum_CertificateLevelTypeEnum-LEED_CERTIFIED');
    case certificate_level_type_enum.LEED_GOLD:
      return t('Enum_CertificateLevelTypeEnum-LEED_GOLD');
    case certificate_level_type_enum.LEED_PLATINUM:
      return t('Enum_CertificateLevelTypeEnum-LEED_PLATINUM');
    case certificate_level_type_enum.LEED_SILVER:
      return t('Enum_CertificateLevelTypeEnum-LEED_SILVER');
  }
};
